// src/theme/ThemeContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const themes = {
    light: {
        name: 'light',
        colors: {
            background: '#ffffff',
            text: '#000000',
            primary: '#1a73e8',
            secondary: '#6c757d',
            surface: '#ffffff',
            overlay: 'rgba(200, 200, 200, 0.3)',
            border: '#dee2e6'
            // border: 'rgba(0, 0, 0, 0.05)',
        }
    },
    dark: {
        name: 'dark',
        colors: {
            background: '#000e1a',
            text: '#ffffff',
            primary: '#4f9eff',
            secondary: '#909090',
            surface: '#162029',
            overlay: 'rgba(0, 0, 0, 0.3)',
            border: '#2d3b45'
            // border: 'rgba(255, 255, 255, 0.05)',
        }
    }
};

export function ThemeProvider({ children }) {
    // const [theme, setTheme] = useState(themes.light);
    const [theme, setTheme] = useState(themes.dark);

    useEffect(() => {
        const root = document.documentElement;
        Object.entries(theme.colors).forEach(([key, value]) => {
            root.style.setProperty(`--theme-${key}`, value);
        });
    }, [theme]);

    const toggleTheme = () => {
        setTheme(theme === themes.light ? themes.dark : themes.light);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);